import {defineStore} from "pinia";
import { io } from 'socket.io-client';

export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        socket: null,
        isConnected: false,
        informs: [],
        errors: [],
        debug: {},
    }),
    actions: {
        initSocket() {
            if (this.socket) return;
            this.socket = io('http://nikita7.fvds.ru');
            this.socket.on('connect', () => {
                this.isConnected = true;
            });
            this.socket.on('disconnect', () => {
                this.isConnected = false;
            });
        },
        onInfo() {
            this.initSocket()
            this.socket.on('info', (data) => {
                this.informs.push(data);
            });
        },
        onError() {
            this.initSocket()
            this.socket.on('error', (data) => {
                this.errors.push(data);
            });
        },
        onDebug(model) {
            this.initSocket()
            this.socket.on(`debug:${model}`, (data) => {
                this.debug[model] = data;
            });
        },
    },
})
